import { z } from "zod";

export const SharedItemMatterSchema = z.object({
  id: z.string(),
  title: z.string().nullable(),
});

export const SharedItemMembershipSchema = z.object({
  objectId: z.string(),
  matters: z.array(SharedItemMatterSchema),
});

export type SharedItemMembership = z.infer<typeof SharedItemMembershipSchema>;
